import React from "react";
import { Link } from "react-router-dom";
// @ts-ignore
import "./AirportsSection.css";

interface Airport {
  code: string;
  slug: string;
  name: string;
  state: string;
}

interface Feature {
  icon: string;
  text: string;
}

const airports: Airport[] = [
  { code: "EWR", slug: "ewr", name: "Newark Airport Limo", state: "New Jersey" },
  { code: "JFK", slug: "jfk", name: "JFK Airport Limo", state: "New York" },
  { code: "LGA", slug: "lga", name: "LaGuardia Airport Limo", state: "New York" },
  { code: "PHL", slug: "phl", name: "Philadelphia Airport Limo", state: "Pennsylvania" },
  { code: "ACY", slug: "acy", name: "Atlantic City Airport Limo", state: "New Jersey" },
  { code: "ALB", slug: "alb", name: "Albany Airport Limo", state: "New York" },
];

const features: Feature[] = [
  { icon: "fa-plane-arrival", text: "Flight Details for Planning" },
  { icon: "fa-clock", text: "Pickup Details Confirmed" },
  { icon: "fa-suitcase", text: "Vehicle Options Reviewed" },
  { icon: "fa-shield-alt", text: "Rate Confirmed Before Booking" },
];

export default function AirportsSection(): JSX.Element {
  const bg = `url(${process.env.PUBLIC_URL}/images/home-banner.webp)`;

  return (
    <section className="airports-section py-5" id="airports">
      <div className="airports-bg" style={{ backgroundImage: bg }}></div>
      <div className="airports-overlay"></div>
      <div className="container" style={{ position: "relative", zIndex: 2 }}>
        <div className="text-center mb-5 gs-anim">
          <span className="section-badge">Airports Served</span>
          <h2 className="section-title">Airport Coverage</h2>
          <p className="section-sub text-white-60">
            We provide private airport transportation to and from six major
            airports. Share your flight details and we confirm current terminal
            instructions, vehicle availability, waiting terms and the exact rate
            before you book.
          </p>
        </div>
        <div className="row g-3 justify-content-center">
          {airports.map((a, i) => (
            <div className="col-6 col-md-4 col-lg gs-anim" key={i}>
              <Link
                to={`/services/airport-transportation/${a.slug}`}
                className="airport-card"
                title={`${a.name} – GS Limo Elite`}
              >
                <div className="airport-code">{a.code}</div>
                <div className="airport-info">
                  <div className="airport-name">{a.name}</div>
                  <div className="airport-state">
                    <i className="fas fa-map-marker-alt"></i> {a.state}
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
        <div className="airports-features row g-3 mt-5">
          {features.map((f, i) => (
            <div className="col-6 col-md-3 gs-anim" key={i}>
              <div className="airport-feature">
                <i className={`fas ${f.icon}`}></i>
                <span>{f.text}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-5 gs-anim">
          <Link
            to="/airports"
            className="btn gs-btn-gold me-3"
            title="View All Airport Services"
          >
            <i className="fas fa-plane me-2"></i> All Airports
          </Link>
          <Link
            to="/get-a-quote"
            className="btn gs-btn-outline-gold"
            style={{ borderColor: "rgba(255,255,255,0.7)", color: "#fff" }}
            title="Request an Airport Transfer"
          >
            Request a Transfer
          </Link>
        </div>
      </div>
    </section>
  );
}
